import { render, staticRenderFns } from "./ipage.vue?vue&type=template&id=2e3a81a8&"
import script from "./ipage.vue?vue&type=script&lang=js&"
export * from "./ipage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports